import { Box } from "@mui/material";
import React, { useRef } from "react";
import { Form } from "react-bootstrap";
import SearchIcon from "../Custom-imeges/SearchIcon";

interface SearchInputProps {
  searchInputValue: string;
  setSearchInputValue: (value: string) => void;
  placeholder: string;
}
export const SearchInput = ({
  searchInputValue,
  setSearchInputValue,
  placeholder,
}: SearchInputProps) => {
  const searchInputRef = useRef<HTMLInputElement>(null);

  return (
    <Box className="search-input-container">
      <Form.Label
        className="mb-0"
        htmlFor="historySearch"
        style={{ marginLeft: "5px" }}
      >
        <SearchIcon className="filter-search-icon" />
      </Form.Label>
      <Form.Control
        id="historySearch"
        placeholder={placeholder}
        ref={searchInputRef}
        value={searchInputValue}
        onChange={(e) => setSearchInputValue(e.target.value)}
      />
    </Box>
  );
};
